var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticlesWizardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33366 4.30581V14.4089H14.8337V16.0928H2.33366C0.666992 16.0928 0.666992 14.4089 0.666992 14.4089V4.30581H2.33366ZM16.5003 2.62196V11.0412H5.66699V2.62196H16.5003ZM16.7503 0.93811H5.41699C4.63366 0.93811 4.00033 1.52746 4.00033 2.24309V11.4201C4.00033 12.1441 4.63366 12.7251 5.41699 12.7251H16.7503C17.5337 12.7251 18.167 12.1441 18.167 11.4201V2.24309C18.167 1.52746 17.5337 0.93811 16.7503 0.93811ZM6.50033 3.46388H9.00032V7.67351H6.50033V3.46388ZM15.667 10.1993H6.50033V8.51543H15.667V10.1993ZM15.667 5.14773H10.667V3.46388H15.667V5.14773ZM15.667 7.67351H10.667V5.98966H15.667V7.67351Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticlesWizardIcon);
export default __webpack_public_path__ + "static/media/articles-wizard-icon.b3868ce9.svg";
export { ForwardRef as ReactComponent };